export default {
  fillInOrder: 'Rellenar el pedido del servicio de compra',
  inputTips: "(las columnas marcadas con <span style='color: red'>*</span> son obligatorias)",
  process: {
    first: 'Rellenar el pedido y enviarlo',
    second: 'Pagar por el producto y el gasto de envío nacional',
    three: 'Esperar a que su producto llegue al almacén',
  },
  productInfo: 'Información del producto',
  productInfoTips:
    'Todos los productos disponibles para el servicio de compra mostrados en acbuy son productos recuperados de plataformas de compra de terceros y no son vendidos directamente por acbuy. Por lo tanto, en caso de que haya algún problema de infracción relacionado con los productos mencionados, todas las responsabilidades incurridas serán asumidas por los vendedores correspondientes en la plataforma de terceros, mientras que acbuy no asumirá ninguna responsabilidad relevante, accesoria o conjunta.',
  fees: 'Tarifas',
  feeStandard: 'Normas de tarifas',
  feeStandardTips:
    "Para el pedido de compra que envíe en esta página, si el producto proviene de plataformas de terceros como Kongfuzi Used Books, Xiaohongshu y Youzan, etc., es posible que no se pueda comprar el producto. El producto está asociado con riesgos de envío, o es posible que se le cobre un cargo de servicio adicional. El cargo de servicio real debe ser verificado por el agente. Para más detalles, consulte 'Centro de ayuda - Normas de tarifas del servicio de compra de terceros'.",
  link: 'Enlace',
  name: 'Nombre',
  remark: 'Observación',
  unitPrice: 'Precio unitario (CNY)',
  qty: 'Cantidad',
  goodsAttr: 'Especificaciones o material',
  chinaPostage: 'Gasto de envío (CNY)',
  holder: {
    inputUrl: 'Pegue la URL del producto',
    inputName: 'Ingrese el nombre del producto aquí (hasta 100 caracteres)',
    inputAttr: 'Ingrese las especificaciones del producto',
    inputRemark:
      'Si el artículo tiene varios patrones, tamaños, colores, etc., especifique lo que necesita aquí en función de la descripción de clasificación en la página del producto. Si compra el mismo producto pero con especificaciones diferentes, separe el pedido.',
    contactName: 'Introduzca su nombre de contacto',
    contactEmail: 'Introduzca su buzón de contacto',
    contactPhone: 'Por favor, introduzca su número de contacto.',
  },
  other: 'Otros (opcional)',
  productImg: 'Imágenes del producto',
  fareTip:
    'El gasto de envío nacional a nuestro almacén (si no está seguro, complete con 0, el agente lo verificará e iniciará el pago)',
  customizedLogisticsForm: 'Formulario de solicitud logística personalizado',
  submitInfo: 'Presentación de información sobre el producto',
  customizedProcess: {
    first: 'Completar el pedido y presentarlo',
    second: 'Presentación de información sobre el producto',
    three: 'Esperando a que acbuy se ponga en contacto con usted',
  },
  deliveryAddress: 'Dirección postal',
  contactDetail: 'Detalles de contacto',
  contactName: 'Nombre del contacto',
  contactPhone: 'Teléfono de contacto',
  contactEmail: 'Correo electrónico de contacto',
  customizedLogisticsInformation: 'Información logística personalizada',
  fromWarehouse: 'Del almacén',
  manuallyFill: 'Rellene manualmente la información del producto',
  contactInfoTips1:
    '·Para servir mejor a usted, complete el formulario con sinceridad y detalle. Dentro de los tres días hábiles siguientes a la presentación de la solicitud, el personal especializado se pondrá en contacto con usted. ',
  contactInfoTips2:
    '·Para los paquetes por debajo de 30kg, se recomienda que los clientes elijan la distribución logística en línea.',
  contactInfoTips3:
    '·Los servicios personalizados solo se refieren al transporte logístico, las mercancías solo se inspeccionan visualmente y no se proporcionan inspecciones detalladas de calidad de las mercancías.',
  myWarehouse: 'Mi Almacén',
  itemName: 'Nombre del proyecto',
  volume1: 'Medidas del paquete después del embalaje',
  volume: 'Volumen(cm)',
  weight: 'Peso',
  length: 'Largo',
  width: 'Ancho',
  height: 'Altura',
  warehouseItem: 'Artículos del almacén',
  manuallyItem: 'Proyecto manual',
  submitSuccess: 'La solicitud de logística personalizada se presentó con éxito.',
  submitMsg:
    'Nos pondremos en contacto con usted lo antes posible, por favor espere pacientemente.',
  inputProductMsg: 'Por favor, introduzca la información del producto',
  selectZone: 'Por favor, elija el número de área del número de contacto.',
  productName: 'Enlace del producto o nombre',
}
